/*
|
|               Manufacturer
_______________________________________________
|
|    This class keep all fields for 
|    new manufacturer. Using when user
|	 add new product, to fill manuacturer data.
|
*/

export class Manufacturer {
    billingStreet                   :string  	= '';
    billingCity                     :string  	= '';
    billingState                    :string  	= '';
    billingZipCode                  :string  	= '';
    billingCountry                  :string  	= '';
    active            			    :boolean 	= true;
    accessory         			    :boolean 	= true;
    bulb              				:boolean 	= true; 
    contact                         :string  	= '';
    emails            				:string[]   = [ '' ]; 
    fax             				:string  	= '';
    fixture           				:boolean 	= true; 
    housing           				:boolean 	= true; 
    id                				:any     	= '';
    name              				:string;
    notes             				:string  	= '';
    phone                           :string  	= '';
    markup            				:number;
    memo              				:string 	= '';
    shippingStreet                  :string  	= 'NY Lighting Group\n1249 Broadway';
    shippingCity                    :string  	= 'NY';
    shippingState                   :string  	= 'NY';
    shippingZipCode                 :string  	= '11557';
    shippingCountry                 :string  	= 'USA';
    website           				:string  	= '';
}


// WEBPACK FOOTER //
// /root/anvel/angular/classes/Manufacturer.ts